(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menmoso-request-flow"] && !Shopify.designMode) return;
  try {
    const requestedService = new URLSearchParams(window.location.search).get('service');
  const serviceOptions = { jump:'Battery jump start', lockout:'Vehicle lockout', tire:'Spare tire installation', fuel:'Emergency fuel delivery' };
  const serviceSelect = document.querySelector('#RequestService');
  if (serviceSelect && serviceOptions[requestedService]) serviceSelect.value = serviceOptions[requestedService];
  } catch(e) { console.error(e); }
})();

})();
